import { app } from '@/main.js'

const defaultState = () => {
    return {
    accessToken: null,
    refreshToken: null,
    authenticated: false,
    tokenExpiry: null,
    jwtPayload:null,
    isSuperAdmin: false,
    isOrganisationAdmin: false,
    isCoreAdmin: false,
    isGeneralUser: false,
    isTrainingAdmin: false,
    token: null,
    loginLoop: 0,
    isTokenExpires: false,
    selectedOrganisation: null,
    accessType: null,
    hasOrg: false,
    isManager: false,
    hasTraining: false,
    hasPentest: false,
    hasPhishing: false,
    hasECC: false,
    hasCoreProduct: false,
    orgProducts: null,
    isPhishingAdmin: false,
    isECCAdmin: false,
    isPentestAdmin: false,
    hasPolicy: false,
    isPolicyAdmin: false,
    isPentester: false,
   }
};

const state = () => ({
    accessToken: null,
    refreshToken: null,
    authenticated: false,
    tokenExpiry: null,
    jwtPayload:null,
    isSuperAdmin: false,
    isOrganisationAdmin: false,
    isCoreAdmin: false,
    isGeneralUser: false,
    isTrainingAdmin: false,
    token: null,
    loginLoop: 0,
    isTokenExpires: false,
    selectedOrganisation: null,
    accessType: null,
    hasOrg: false,
    isManager: false,
    hasTraining: false,
    hasPentest: false,
    hasPhishing: false,
    hasECC: false,
    hasCoreProduct: false,
    orgProducts: null,
    isPhishingAdmin: false,
    isECCAdmin: false,
    isPentestAdmin: false,
    hasPolicy: false,
    isPolicyAdmin: false,
    isPentester: false,
});


const getters = {
};

const actions = {
    resetState ({commit}) {
        commit('resetState');
    },

    logout({ commit, state }, errorMessage = "") {
        let logoutUrl = state.token
        ? `${app.config.globalProperties.$config.getLoginLink()}&token=${state.token}&logout=true`
        : `${app.config.globalProperties.$config.getLoginLink()}&logout=true`;

        if (state.loginLoop > 0) {
            logoutUrl = `${logoutUrl}&login_loop=${state.loginLoop}`;
        }

        if (state.isTokenExpires) {
            logoutUrl = `${logoutUrl}&error=TOKEN_EXPIRE`;
        }

        if (errorMessage) {
            logoutUrl = `${logoutUrl}&message=${encodeURIComponent(errorMessage)}`;
        }

        commit("resetState");
        this.dispatch("user/resetState");
        localStorage.clear();

        window.location.href = logoutUrl;
    }
}


const mutations = {
    authenticated(state, authenticated) {
        state.authenticated = authenticated;
    },

    setAccessToken(state, accessToken){
        state.accessToken = accessToken;
    },

    setToken(state, token){
        state.token = token;
    },

    setTokenExpires(state){
        state.isTokenExpires = true;
    },

    setJwtPayload(state, payload) {
        state.jwtPayload = payload;
        state.tokenExpiry = payload.expires_at;
        state.isManager = payload.is_manager;

        if (payload && payload.roles) {
            state.isSuperAdmin = payload.roles.includes("super_admin");

            // for vertex roles
            if (!state.isSuperAdmin) {
                state.accessType = payload.roles.includes("vertex_analyst") ? 'vertex_analyst' : null;
                state.isPentester = payload.roles.includes("penetration_tester");
            }
        }


        state.hasCoreProduct = false;
        let isAnyAdmin = false;
        let isAnyGeneralUser = false;

        if (payload.organisation_role) {
            state.hasOrg = true;

            if (payload.organisation_role[0].products) {
                state.isOrganisationAdmin = payload.organisation_role[0].is_organisation_admin;

                payload.organisation_role[0].products.forEach((p) => {
                    if (["automated_test_phishing_campaigns", "cyber_security_online_awareness_training", "pentester_platform", "email_compromise_check", "policy_management"].includes(p.product)) {
                        state.hasTraining = p.product === "cyber_security_online_awareness_training" ? true : state.hasTraining;
                        state.hasPentest = p.product === "pentester_platform" ? true : state.hasPentest;
                        state.hasPhishing = p.product === "automated_test_phishing_campaigns" ? true : state.hasPhishing;
                        state.hasECC = p.product === "email_compromise_check" ? true : state.hasECC;
                        state.hasPolicy = p.product === "policy_management" ? true : state.hasPolicy;


                        if (p.roles.includes("admin")) {
                            isAnyAdmin = true;
                        }
                        if (p.roles.includes("general_user")) {
                            isAnyGeneralUser = true;
                        }

                        this.commit("auth/updateRoles", { product: p.product, roles: p.roles });
                    }

                    //count core products only
                    if (["automated_test_phishing_campaigns", "cyber_security_online_awareness_training", "email_compromise_check", "policy_management"].includes(p.product)) {
                        state.hasCoreProduct = true;
                    }
                });

                // After looping through products
                state.isCoreAdmin = isAnyAdmin;
                state.isGeneralUser = !isAnyAdmin && isAnyGeneralUser;

                if (state.isOrganisationAdmin == true) {
                    this.isPentestAdmin = true;
                    this.isPhishingAdmin = true;
                    this.isECCAdmin = true;
                    this.isTrainingAdmin = true;
                    this.isPolicyAdmin = true;
                }
            }
        }

        // If only "pentester_platform" is present, log out the user
        if (!state.hasCoreProduct && !state.isSuperAdmin) {
            this.dispatch("auth/logout", "User is not permissioned to access this product. Please contact your administrator.");
        }
    },

    updateRoles(state, { product, roles }) {
        if (product === "cyber_security_online_awareness_training") {
            state.hasTraining = true;
        } else if (product === "pentester_platform") {
            state.hasPentest = true;
        } else if (product === "automated_test_phishing_campaigns") {
            state.hasPhishing = true;
        } else if (product === "policy_management") {
            state.hasPolicy = true;
        }

        let isAdminForThisProduct = roles.includes("admin");

        // Set admin flags
        if (isAdminForThisProduct) {
            state.isCoreAdmin = true;
            if (product === "cyber_security_online_awareness_training") {
                state.isTrainingAdmin = true;
            }
            if (product === "automated_test_phishing_campaigns") {
                state.isPhishingAdmin = true;
            }
            if (product === "email_compromise_check") {
                state.isECCAdmin = true;
            }
            if (product === "pentester_platform") {
                state.isPentestAdmin = true;
            }
            if (product === "policy_management") {
                state.isPolicyAdmin = true;
            }

        }
    },

    resetState(state) {
        Object.assign(state, defaultState());
    },

    setLoginLoop(state, loginLoop) {
        state.loginLoop = loginLoop > 0 ? loginLoop : 0;
    },

    setOrgProducts(state, products) {
        // Filter out products that have no organisation_product_id
        const filteredProducts = products.filter(p => p.organisation_product_id);

        // Store filtered products in state
        state.orgProducts = filteredProducts;

        // Check if "Training" exists among the products
        state.hasTraining = filteredProducts.some(p => p.product.toLowerCase() === "cyber_security_online_awareness_training");
        state.hasPentest = filteredProducts.some(p => p.product.toLowerCase() === "pentester_platform");
        state.hasPhishing = filteredProducts.some(p => p.product.toLowerCase() === "automated_test_phishing_campaigns");
        state.hasECC = filteredProducts.some(p => p.product.toLowerCase() === "email compromise check");
        state.hasPolicy = filteredProducts.some(p => p.product.toLowerCase() === "policy management");

    }
};

export default {
  name: 'auth',
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};